import EXTERNAL_LINKS from '../../../constants/externalLinks';

export const INFORMATION_STEPS_LIST = [
  {
    value: 'Book a Camera Operator',
    prefix: 'bookings',
    prefixSize: 24,
    label: 'Go to Bookings',
    link: EXTERNAL_LINKS.bookingCameraOperatorURL
  },
  {
    value: 'Need help with your video?',
    prefix: 'admin',
    prefixSize: 24,
    label: 'Consult a Creative Producer',
    link: EXTERNAL_LINKS.professionalServicesURL
  },
  {
    value: 'Shootsta Learning Academy',
    prefix: 'learning',
    prefixSize: 24,
    label: 'Get Educated',
    link: EXTERNAL_LINKS.shootstaLearningAcademyURL
  }
] as const;
